module.exports = __webpack_public_path__ + "static/media/example02-02.8b0cf4c2.svg";